import { ApprovalI, ShowLastDataPayload, approvalsTypes } from "../approvals/approvalsTypes";
import { RealTimeDataReducer, realTimeData } from "./types";

export const initialState: RealTimeDataReducer = {
  approvalsStack: [],
};

const ACTION_REDUCER = {
  [realTimeData.ADD_STACK]: (state: RealTimeDataReducer, { payload }: { payload: { approval: ApprovalI } }) => ({
    ...state,
    approvalsStack: [ ...state.approvalsStack, payload.approval ],
  }),
  [realTimeData.UPDATE_STACK]: (state: RealTimeDataReducer, { payload }: { payload: { approval: ApprovalI } }) => {
    let approvalsStack = [ ...state.approvalsStack ];
    const index = approvalsStack.findIndex(
      (approval: ApprovalI) => approval.approval_id === payload?.approval.approval_id,
    );

    if (index !== -1) {
      approvalsStack[index] = payload.approval;
    } else {
      approvalsStack = [ ...approvalsStack, payload.approval ];
    }

    return {
      ...state,
      approvalsStack,
    };
  },
  [realTimeData.REMOVE_STACK]: (
    state: RealTimeDataReducer,
    { payload }: { payload: { approval: { approval_id: number } } },
  ) => {
    const approvals = [
      ...state.approvalsStack.filter((approval: ApprovalI) => approval?.approval_id !== payload?.approval?.approval_id),
    ];

    return {
      ...state,
      approvalsStack: approvals,
    };
  },
  [realTimeData.RESET_STACK]: (state: RealTimeDataReducer, { payload }: { payload: string }) => {
    const approvals = [ ...state.approvalsStack.filter((approval: ApprovalI) => approval?.section !== payload) ];

    return {
      ...state,
      approvalsStack : approvals,
      section        : undefined,
    };
  },
  [approvalsTypes.SHOW_LAST_DATA]: (state: RealTimeDataReducer, { payload }: { payload: ShowLastDataPayload }) => ({
    ...state,
    section: payload.section,
  }),
};

const reducer = (state: RealTimeDataReducer = initialState, action: any) => {
  const actionReducer = ACTION_REDUCER[action.type];

  return actionReducer ? actionReducer(state, action) : state;
};

export default reducer;
